import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/element';
import 'assets/scss/global.scss';
import 'element-ui/lib/theme-chalk/index.css';
import rules from './components/common/rules';
import 'default-passive-events';

axios.defaults.timeout = 20000;
Vue.prototype.$http = axios;
Vue.prototype.$rules = rules;
Vue.prototype.$now = new Date().toTimeString().replace(' GMT+0800 (中国标准时间)', '');
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
